import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";

import {
  formatMonetary,
  timeStampToDate,
  formatUpperCase,
} from "../../../../utils/formats";
import Table from "../../subcomponents/Table";
import TablePagination from "@mui/material/TablePagination";
import { toast } from "react-toastify";
import { retrieveOtherProposals } from "../../../../services/frontCredito";
import { makeStyles } from "@mui/styles";

const style = {
  justify: "center",
};

const useStyles = makeStyles({
  caption: {
    padding: 8,
    fontSize: "1.25rem",
  },
  toolbar: {
    "& > p:nth-of-type(2)": {
      fontSize: "1.25rem",
      color: "red",
      fontWeight: 600,
    },
  },
});

const columns = [
  {
    id: "numeroProposta",
    name: "N° da proposta",
    style,
  },
  {
    id: "data",
    name: "Data",
    render: timeStampToDate,
    style,
  },
  {
    id: "valor",
    name: "Valor",
    render: formatMonetary,
    style,
  },
  {
    id: "parcela",
    name: "Parcela",
    render: (id, value, entry) =>
      `${entry.quantidadePrestacoes} x ${formatMonetary(entry.valorPrestacao)}`,
    style,
  },
  {
    id: "pedidoOrcamento",
    name: "Pedido",
    style,
  },
  {
    id: "situacao",
    name: "Situação",
    render: formatUpperCase,
    style,
  },
  {
    id: "status",
    name: "Status",
    render: formatUpperCase,
    style,
  },
];

const OutrasPropostasSection = (props) => {
  const [totalElements, setTotalElements] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const { cpfCnpj, proposalNumber } = props;

  const [filters, setFilters] = useState({
    cpfCnpj: cpfCnpj,
    proposalNumber: proposalNumber,
    pageable: {
      page: 0,
      size: 5,
      sortColumn: "numeroProposta",
      sortDirection: "ASC",
    },
  });

  const classes = useStyles();

  useEffect(() => {
    getDataByFilters();
  }, [filters]);

  const getDataByFilters = () => {
    setIsLoading(true);
    setRows([]);
    setTotalElements(0);

    retrieveOtherProposals(filters)
      .then((response) => {
        if (response && (response.status === 201 || response.status === 200)) {
          const {
            data: { content, totalElements },
          } = response;

          setRows(content);
          setTotalElements(totalElements);
        } else if (!response) {
          toast.error("Erro ao buscar os dados.");
        }
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error("Erro ao buscar os dados.");
        }
      })
      .finally(() => setIsLoading(false));
  };

  const handleChangePage = (p, newPage) => {
    setFilters({
      ...filters,
      cpfCnpj: cpfCnpj,
      pageable: {
        ...filters.pageable,
        page: newPage,
      },
    });
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Table
            loading={isLoading}
            noDataMessage="Sem dados."
            entries={rows}
            columns={columns}
          />
          <TablePagination
            component="div"
            classes={{
              toolbar: classes.toolbar,
              caption: classes.caption,
            }}
            count={totalElements}
            page={filters.pageable.page || 0}
            labelDisplayedRows={({ from, to, count }) =>
              `${from} - ${to} de ${count}`
            }
            onPageChange={handleChangePage}
            rowsPerPageOptions={[]}
            rowsPerPage={filters.pageable.size}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default OutrasPropostasSection;
